<template>

	<div>
        <div class="wrap">
          <div class="articles">
            <div class="articles_question">
              {{card.title}}
            </div>
            <div class="articles_answer">
              {{bank.text}}
            </div>
          </div>
          <img src="../../assets/img/Image1.png" alt="">
          <div class="articles mt-5">
            <div class="articles_text">
              {{card.text}}
            </div>
            <div class="articles_table">
              <div class="articles_table__title">{{bank.title}}</div>
              <ul>
                <li>
                  <span>Cinema </span>
                  <span>$ 34.20</span>
                </li>
                <li class="active">
                  <span>secrgrd.com</span>
                  <span>$ 75.44</span>
                </li>
                <li>
                  <span>City bus  </span>
                  <span>$ 15.40</span>
                </li>
              </ul>
            </div>
          </div>

        </div>
        <unsubscribe/>
		<GetInTouch/>
		<Questions/>
	</div>

</template>

<script>
import {mapState} from 'vuex';
	import GetInTouch from './GetInTouch';
	import Questions from './Questions';
    import Unsubscribe from "@/components/Unsubscribe/Index";

    export default {
        name: "Main",
        components: {
            Unsubscribe,
            GetInTouch, Questions
        },
      computed:{
        ...mapState([
          'vocab', 'locale', 'specific'
        ]),
        card() {
          return this.vocab[this.locale].card;
        },
        bank() {
          return this.vocab[this.locale].bank;
        },
      }
    }
</script>

<style lang="scss">
  .articles {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    margin-bottom: 50px;

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }


    &_question {
      font-size: 45px;
      margin-bottom: 15px;
      font-weight: bold;
    }

    &_answer {
      background: #D9D9D9;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      margin-bottom: 50px;
      padding: 20px;
    }

    &_table {
      &__title {
        background-color: #fff;
        font-size: 24px;
        color: #000;
        margin-bottom: 10px;
        padding: 10px;
        text-align: center;
      }
      ul {
        background-color: #fff;
        padding: 10px;
        list-style: none;
        li {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #979797;
          line-height: 40px;
        }
        li.active {
          font-weight: bold;
          font-size: 25px;
        }
      }
    }
  }

  .wrap {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 150px;
    padding-left: 5px;
    padding-right: 5px;

    .mt-5 {
      background-color: #D9D9D9;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      margin-top: 100px;
      padding: 20px;
    }

    img {
      border-radius: 10px;
      width: 100%;
    }
  }
</style>
